'use strict';

// WINDOW READY
$(document).ready(function () {

    // MODAL
    var modalWasSeen = window.localStorage.getItem('modalWasSeen');

    if (!modalWasSeen) {
        var windowWasScrolledToBottom = false;

        window.addEventListener('scroll', function (event) {
            // If user scrolls to 1000px at some point
            if (this.scrollY > 1000) {
                windowWasScrolledToBottom = true;
            }

            // If user is back on top & has previously scrolled to 1000px & has never seen modal
            if (this.scrollY === 0 && windowWasScrolledToBottom && !modalWasSeen) {
                window.localStorage.setItem('modalWasSeen', 'yes');
                modalWasSeen = true;
                $('body').addClass('is-modal-open');
                $('.modal.enews-form').addClass('is-open');
            }
        }, false);
    }

    // Close modal
    $('.close-modal').on('click', function () {
        $('body').removeClass('is-modal-open');
        $('.modal').removeClass('is-open');
    });

    // OPEN FAQ

    $(".faq-title").each(function () {
        $(this).click(function () {

            if ($(this).parent().hasClass("open")) {
                $(this).parent().removeClass("open").find(".faq-content").slideUp("300");
            } else {
                $(this).parent().addClass("open").find(".faq-content").slideDown("300");
            }
        });
    });

    $('#package-date').datepicker({
        //language: 'en',
        inline: true
    });

    // $(function() {
    //     $('input[name="daterange"]').daterangepicker({
    //         singleDatePicker: true,
    //         // inline: true,
    //         // alwaysShowCalendars: true,
    //         opens: 'inline'
    //     }, function(start, end, label) {
    //         console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));
    //     });
    // });


    // ADD A DIV INTO A FORM FOR INPUT BACKGROUND

    $("#newsletter_signup .form-group input").each(function () {
        $(this).after("<div class='input-gfx'></div>");
    });

    // SHORTEN TEXT

    if ($(window).width() < 1025) {
        $(function () {
            $(".small-blog p").each(function (i) {
                len = $(this).text().length;
                if (len > 120) {
                    $(this).text($(this).text().substr(0, 120) + '...');
                }
            });
        });
    }

    if ($(window).width() < 476) {
        $(function () {
            $(".small-blog h3").each(function (i) {
                len = $(this).text().length;
                if (len > 28) {
                    $(this).text($(this).text().substr(0, 28) + '...');
                }
            });
        });
    }

    // SHOW / HIDE MOBILE MENU

    $(".mobile-menu-toggler").on("click", function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active").parent().find(".menu-main").slideUp("300");
            $("body").removeClass("mobile-menu-open");
        } else {
            $(this).addClass("active").parent().find(".menu-main").slideDown("300");
            $("body").addClass("mobile-menu-open");
        }
    });

    // SHOW SECONDARY MENU IN MOBILE MENU

    $(".menu-main li.has-children").each(function () {
        $(this).on("click", function () {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active").find(".menu-dropdown").slideUp("300");
            } else {
                $(this).addClass("active").find(".menu-dropdown").slideDown("300");
            }
        });
    });

    // SHOW FOOTER MENU ON TABLET

    if ($(window).width() < 787) {
        $(".footer-title").each(function () {
            $(this).on("click", function () {
                if ($(this).hasClass("active")) {
                    $(this).removeClass("active").parent().find(".footer-menu").slideUp("300");
                } else {
                    $(this).addClass("active").parent().find(".footer-menu").slideDown("300");
                }
            });
        });
    }

    // PARALLAX EFFECT

    if ($("#parallax-bg").length) {
        var controller = new ScrollMagic.Controller({ globalSceneOptions: { triggerHook: "onEnter", duration: "120%" } });

        new ScrollMagic.Scene({ triggerElement: "#parallax-bg" }).setTween("#parallax-bg > div", { y: "80%", ease: Linear.easeNone })
        // .addIndicators()
        .addTo(controller);
    }

    // BACK TO TOP ICON

    $(".back-to-top span").click(function (e) {
        e.preventDefault();
        //1 second of animation time
        //html works for FFX but not Chrome
        //body works for Chrome but not FFX
        //This strange selector seems to work universally
        $("html, body").animate({ scrollTop: 0 }, 1000);
    });

    //HOME BLOGS SLIDER

    $('.home-blogs-slider').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        autoplaySpeed: 5000,
        speed: 300,
        prevArrow: '<div class="nav-arrow nav-prev"></div>',
        nextArrow: '<div class="nav-arrow nav-next"></div>',
        dots: false,
        responsive: [{
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        }]
    });

    //HOME QUOTES SLIDER

    $('.home-quotes-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: true,
        autoplaySpeed: 5000,
        prevArrow: '<div class="nav-arrow nav-prev"></div>',
        nextArrow: '<div class="nav-arrow nav-next"></div>',
        dots: true,
        responsive: [{
            breakpoint: 581,
            settings: {
                arrows: false,
                dots: true
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        }]
    });

    // SIMILAR BLOGS SLIDER

    $('.similar-blogs-slider').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        autoplaySpeed: 5000,
        speed: 300,
        prevArrow: '<div class="nav-arrow nav-prev"></div>',
        nextArrow: '<div class="nav-arrow nav-next"></div>',
        dots: false,
        responsive: [{
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        }]
    });

    // SIMILAR BLOGS SLIDER

    $('.other-packages-slider').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        autoplaySpeed: 5000,
        speed: 300,
        prevArrow: '<div class="nav-arrow nav-prev"></div>',
        nextArrow: '<div class="nav-arrow nav-next"></div>',
        dots: false,
        responsive: [{
            breakpoint: 1400,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        }, {
            breakpoint: 700,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        }]
    });

    // Specto faker
    $(".menu-lang select").specto_faker({
        on_change: function on_change(newVal, jsEvent) {
            window.location.href = newVal;
        } //callback function after value has changed //e.g. function(newVal, jsEvent){}
        //animated: true
    });

    // Specto faker
    $(".pick-time-cont .faker").specto_faker();

    // Menu
    menuAnimation();

    // RESIZE WATCH

    $(window).resize(function () {

        $.fn.matchHeight._update();

        // Clear body classes and open menu
        $("body").removeClass('is-open-menu is-dropdown');
        $(".navigation-wrap").removeAttr('style');
    });

    // SCROLL WATCH
    $(window).scroll(function () {

        var scrol_position_bottom = $(this).scrollTop() + $(this).height();

        //On top button
        if ($(this).scrollTop() > 300) {
            $('.ontop').addClass('is-visible');
        } else {
            $('.ontop').removeClass('is-visible');
        }
    });

    /* WINDOW LOAD WATCH */
    $(window).on('load', function () {

        //$('.loader-wrapper').fadeOut(300);

        // Slickslider
        slickSlidersInit();
        // Gallery modal menu
        //galleryModalInit();

        // Set min-height for article product section
        //articleProduct();

        // Match height added to class equal-height
        $('.equal-height').matchHeight();

        $('.equal-height-inner').matchHeight();

        $('.equal-height-not-by-row').matchHeight({
            byRow: false
        });

        $('.equal-height-row999 > div').matchHeight({
            byRow: true,
            property: 'height'
        });
        // Form validatin
        //formValidation();

        $(".btn-more-less").each(function () {
            $(this).click(function (e) {
                e.preventDefault();
                $(this).siblings('.collapsible').slideToggle("300");
                $(this).hide();
                $(this).siblings('.btn-more-less').show();
            });
        });
    });

    // get instagram photos
    var instagramUrl = 'https://api.instagram.com/v1/users/self/media/recent';
    if ($('#instagram_posts').length > 0) {
        loadInstagramPhotos(instagramUrl);
    }

    function loadInstagramPhotos(url) {
        var token = $('#instagram_posts').data('instToken');
        var num_photos = 10;
        $.ajax({
            url: url,
            dataType: 'jsonp',
            type: 'GET',
            data: { access_token: token, count: num_photos },
            success: function success(data) {
                if (data.data !== undefined) {
                    for (x in data.data) {
                        $('#instagram_posts').append('<a target="_blank" href="' + data.data[x].link + '" class="post-single" style="background: url(' + data.data[x].images.standard_resolution.url + ') no-repeat center center"></a>');
                    }
                    instagramUrl = data.pagination.next_url;
                } else {
                    console.log('error getting data');
                }
            },
            error: function error(data) {
                console.log(data);
            }
        });
    }

    // Change classes for mobile blog post layout
    if (screen.width < 450 && $('.home-blogs-slider').length) {
        $('.home-blogs-slider').slick('unslick');
        document.querySelectorAll('.small-blog').forEach(function (smallBlog) {
            smallBlog.classList.add('big-blog');
            smallBlog.classList.remove('small-blog');
        });
    }
});